<ng-container *ngIf="shopDetails$ | async as shop">
  <div class="header-wrap">
    <div class="tags">
      <div 
        class="tag"
        [ngStyle]="{'background-color': shop.blocked ? '#475160' : shop.type === 'Existing Retailer' ? '#DC0093' : '#12B583'}"
      >{{ shop.type }}</div>
      <div class="tag small"
        [ngStyle]="{'background-color': shop.tag === 'General Trade' ? '#FFB51F' : shop.tag === 'Forecourt' ? '#42C9D8' : '#DB5C1E'}"
      >
        <img *ngIf="shop.tag === 'General Trade'" src="/assets/img/game/general-trade-icon.svg">
        <img *ngIf="shop.tag === 'Forecourt'" src="/assets/img/game/forecourt-icon.svg">
        <img *ngIf="shop.tag === 'Vape Store'" src="/assets/img/game/vape-shop-icon.svg">
        <div>{{ shop.tag }}</div>
      </div>
    </div>
    <div class="button" *ngIf="!singleView">
      <ng-container *ngIf="!shop.blocked">
        <img
          *ngIf="!shop.chosen"
          src="assets/img/game/select-retailer-button.svg"
          (click)="selectShop(shop)"
        >
        <ng-container *ngIf="shop.chosen">
          <img
            *ngIf="shop.type === 'Existing Retailer'"
            src="assets/img/game/retailer-selected-button.svg"
            (click)="deselectShop(shop)"
          >
          <img
            *ngIf="shop.type === 'New Prospect'"
            src="assets/img/game/prospect-selected-button.svg"
            (click)="deselectShop(shop)"
          >
        </ng-container>
      </ng-container>
      <img
        *ngIf="shop.blocked"
        src="assets/img/game/unavailable-retailer-button.svg"
      >
    </div>
  </div>
  <div class="bottom-wrap">
    <div class="bottom-header">Retailer No.{{ shopId }}</div>
    <div class="bottom-content">
      <div class="table-wrap">
        <div class="column highlighted">
          <div class="row">
            <div>CC Volume</div>
            <div class="number">{{ shop.cc_volume }}</div>
          </div>
          <div class="row">
            <div>Nic Pouch Volume</div>
            <div class="number">{{ shop.npv }}</div>
          </div>
          <div class="row">
            <div>Vape Spend</div>
            <div class="number">{{ shop.vape_spend }}</div>
          </div>
          <div class="row">
            <div>Multi-Cat Apetite</div>
            <div class="number">{{ shop.mca }}</div>
          </div>
          <div class="row">
            <div>DM Skill Level</div>
            <div class="number">{{ shop.dm_skill }}</div>
          </div>
          <div class="row">
            <div>DM Will Level</div>
            <div class="number">{{ shop.dm_will }}</div>
          </div>
        </div>
        <div class="column">
          <div class="row">
            <div>Staff Skill Level</div>
            <div class="number">{{ shop.staff_skill }}</div>
          </div>
          <div class="row">
            <div>Staff Will Level</div>
            <div class="number">{{ shop.staff_will }}</div>
          </div>
          <div class="row">
            <div>Footfall Count</div>
            <div class="number">{{ shop.footfall }}</div>
          </div>
        </div>
      </div>
      <div class="shop-img">
        <img 
          *ngIf="shop.tag === 'General Trade'"
          src="/assets/img/game/shop.svg"
          [ngStyle]="{'margin-top': '-1em', 'width': '29em'}"
        >
        <img
          *ngIf="shop.tag === 'Forecourt'"
          src="/assets/img/game/fuel.svg"
          [ngStyle]="{'margin-top': '-1em', 'width': '33em', 'margin-bottom': '4em'}"
        >
        <img
          *ngIf="shop.tag === 'Vape Store'"
          src="/assets/img/game/vape-shop.svg"
          [ngStyle]="{'margin-top': '-2em', 'width': '27em'}"
        >
      </div>
      <img *ngIf="!singleView" class="swipable" src="/assets/img/game/swipable.svg">
    </div>
    <div class="district-info"
      [ngStyle]="{'bottom': singleView ? '1em' : '2em'}"  
    ><span
        [ngStyle]="{'color': getColor(shop.district)}"
      >{{ shop.district }}</span> District</div>
  </div>
</ng-container>
